var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditoracces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12321_14181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31262 11C1.35899 11 1.40537 10.993 1.45087 10.9773L4.07587 10.1023C4.13974 10.0813 4.19924 10.0445 4.24649 9.99638L11.2474 2.99725C11.418 2.82663 11.418 2.54925 11.2474 2.37863L9.49737 0.627755C9.32674 0.45713 9.04937 0.45713 8.87874 0.627755L1.87787 7.62775C1.82974 7.67588 1.79299 7.7345 1.77199 7.79838L0.896993 10.4234C0.844493 10.5809 0.885618 10.7541 1.00287 10.8714C1.08687 10.9545 1.19799 10.9991 1.31262 10.9991V11Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 12.75H0.875C0.391125 12.75 0 13.142 0 13.625C0 14.108 0.391125 14.5 0.875 14.5H13.125C13.6089 14.5 14 14.108 14 13.625C14 13.142 13.6089 12.75 13.125 12.75Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12321_14181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditoracces);
export default __webpack_public_path__ + "static/media/editoracces.8a1239a33ede2ac0226857ec29b914b0.svg";
export { ForwardRef as ReactComponent };